module.exports = __webpack_public_path__ + "static/img/btn_logob_nor.1660e63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_logob_nor.png
// module id = fT9v
// module chunks = 1